var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7999 125H101.2C115 125 120.5 116.55 121.15 106.25L123.75 64.95C124.45 54.15 115.85 45 105 45C101.95 45 99.1499 43.25 97.7499 40.55L94.1499 33.3C91.8499 28.75 85.8499 25 80.7499 25H69.2999C64.1499 25 58.1499 28.75 55.8499 33.3L52.2499 40.55C50.8499 43.25 48.0499 45 44.9999 45C34.1499 45 25.5499 54.15 26.2499 64.95L28.8499 106.25C29.4499 116.55 34.9999 125 48.7999 125Z",
    stroke: "#D0D0D0",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 55H82.5",
    stroke: "#D0D0D0",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 105C83.95 105 91.25 97.7 91.25 88.75C91.25 79.8 83.95 72.5 75 72.5C66.05 72.5 58.75 79.8 58.75 88.75C58.75 97.7 66.05 105 75 105Z",
    stroke: "#D0D0D0",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9bf1f1682ce131588643ef41106dbfa6.svg";
export { ForwardRef as ReactComponent };